import React from 'react';
import PropTypes from 'prop-types';
import { InputNumber } from 'antd';

const InputNumberItem = ({ 
  title, 
  min, 
  max, 
  title_class, 
  input_class, 
  container_class, 
  placeholder, 
  value, 
  onChange 
}) => {
  return (
    <div className={container_class}>
      {
        title &&
        <p className={`ori-b-mrgn-5 ori-capitalize-first ${title_class}`}>{title}</p>
      }
      <InputNumber
        min={min}
        max={max}
        placeholder={placeholder}
        className={input_class}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

InputNumberItem.propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func,
  title_class: PropTypes.string,
  input_class: PropTypes.string,
  container_class: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number
};

InputNumberItem.defaultProps = {
  input_class: "ori-font-xs",
  container_class: "ori-tb-pad-5",
};

export default InputNumberItem;



// WEBPACK FOOTER //
// ./src/components/form/inputnumberitem/index.js